import React from 'react';
import MetaTags from '../../../components/MetaTags';
import { useEventPage } from './useEventPage';
import { EventPageView } from './EventPageView';

export const EventPage: React.FC = () => {
    const { metaTags, ...viewProps } = useEventPage();
    return (
        <>
            <MetaTags {...metaTags} />
            <EventPageView {...viewProps} />
        </>
    );
};
